import React, { Component } from 'react'

export default class Projects extends Component {
  render() {
    return (
      <div>
				<section className="colorlib-about" data-section="projects">
					<div className="colorlib-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" >
								<span className="heading-meta">My Work</span>
								<h2 className="colorlib-heading animate-box">Recent Projects</h2>
							</div>
						</div>
						<div className="row row-pt-md ">

							<div className="col-md-4 text-center animate-box">
                				<div className="services color-2">
                    				<span className="icon">
                        				<i className="icon-data" />
                    				</span>	
                    				<div className="desc">
                        				<h3><a className="btn btn-danger btn-learn" href="https://github.com/poonam9009/Vanilla-Cart" target="_blank" rel="noopener noreferrer">Vanilla-Cart</a></h3>
										<p >
											An e-commerce website which is built with python and django framework.Here you can but basic things
											and for payment you can use paytm payment option. SQLite is used for databse purpose.
										</p>
                    				</div>
                				</div>
           			 		</div>

							

							<div className="col-md-4 text-center animate-box">
                				<div className="services color-1">
                    				<span className="icon">
                        				<i className="icon-bulb" />
                    				</span>	
                    				<div className="desc">
                        				<h3><a className="btn btn-primary btn-learn" href = "https://github.com/poonam9009/blog-webapp" target="_blank" rel="noopener noreferrer">TechFic</a></h3>
                        				<p>A Blog webapp using python & Django.
											You can see blogpost after loging in by your email id.
											you can comment on post and also can share a post on your facebook.Mysql is used for database </p>
                    				</div>
                				</div>
           			 		</div>

							<div className="col-md-4 text-center animate-box">
                				<div className="services color-3">
                    				<span className="icon">
                        				<i className="icon-phone3" />
                    				</span>	
                    				<div className="desc">
                        				<h3><a className=" btn btn-warning btn-learn" href = "https://github.com/poonam9009/Eat-It-App" target="_blank" rel="noopener noreferrer" >Eat It App</a></h3>
                        				<p>A food ordering app with features like sign up ,sign in, add to cart, place order. 
											navigation bar has used for showing the menu.
											order can be placed using email id.for database sql is used in it.</p>
                    				</div>
                				</div>
           			 		</div>
							
						</div>
						<div className="row">
							<div className="col-md-12 animate-box">
								{/* <p><a href="#" className="btn btn-primary btn-lg btn-load-more">Load more <i className="icon-reload" /></a></p> */}
							</div>
						</div>
					</div>
				</section>
       </div>
    )
  }
}
